import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardHeader,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import Iconify from '../../../components/Iconify';
import Label from '../../../components/Label';
import { stripeSubscriptionUrl } from '../../../helpers/subscriptions';

const fEur = (n) =>
  new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(n) || 0);

const fDate = (iso) => (iso ? new Date(iso).toLocaleDateString('es-ES') : '—');

// `canceledRenewals` (anuales) y `canceledMonthly` (mensuales) tienen el mismo shape;
// se mezclan en una sola tabla con un `kind` para distinguirlas.
export default function CancellationsTable({ renewals, monthly }) {
  const rows = [
    ...(renewals || []).map((r) => ({ ...r, kind: 'anual' })),
    ...(monthly || []).map((r) => ({ ...r, kind: 'mensual' })),
  ];

  return (
    <Card>
      <CardHeader
        title="Cancelaciones próximas"
        subheader={`${rows.length} suscripción${rows.length === 1 ? '' : 'es'} con baja programada`}
      />
      {rows.length === 0 ? (
        <Box sx={{ p: 3 }}>
          <Typography variant="body2" color="text.secondary">
            No hay cancelaciones programadas.
          </Typography>
        </Box>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Tipo</TableCell>
                <TableCell>Fuente</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Producto</TableCell>
                <TableCell>Fin del periodo</TableCell>
                <TableCell align="right">Asientos</TableCell>
                <TableCell align="right">EUR / ciclo</TableCell>
                <TableCell align="right" />
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={`${r.kind}-${r.id}`} hover>
                  <TableCell>
                    <Label color={r.kind === 'anual' ? 'warning' : 'info'}>{r.kind}</Label>
                  </TableCell>
                  <TableCell>
                    <Label color={r.source === 'manual' ? 'default' : 'info'}>{r.source || 'stripe'}</Label>
                  </TableCell>
                  <TableCell>{r.customerEmail || '—'}</TableCell>
                  <TableCell>{r.productName || '—'}</TableCell>
                  <TableCell>{fDate(r.currentPeriodEnd)}</TableCell>
                  <TableCell align="right">{r.qty ?? '—'}</TableCell>
                  <TableCell align="right">{fEur(r.cycleAmountEUR)}</TableCell>
                  <TableCell align="right">
                    {r.source === 'manual' ? null : (
                      <Tooltip title="Ver en Stripe">
                        <IconButton
                          size="small"
                          component="a"
                          href={stripeSubscriptionUrl(r.id)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Iconify icon="eva:external-link-outline" width={18} height={18} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Card>
  );
}

CancellationsTable.propTypes = {
  renewals: PropTypes.array,
  monthly: PropTypes.array,
};
